module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Vwn3yL/tc-custom/9781454932918.jpg?1718071579387",
      "alt": "This image is the cover for the book How to House-Plant"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("How to House-Plant\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this beginner’s guide to indoor gardening, you’ll learn how to care for fifty of the most popular houseplants.")]), _c('br'), _c('br'), _vm._v("Houseplants are more popular than ever: as expert writer and gardening enthusiast Heather Rodino notes, “plants have demonstrated therapeutic value, clean the air, and are an affordable way of decorating, adding beauty to your home, and making even the smallest rented space feel like your own.” She offers a lighthearted, colorfully illustrated overview of caring for your indoor garden, profiling fifty of the most popular houseplants, from the Boston fern and the fiddle-leaf fig to the moth orchid. Her accessible advice on handling pests and diseases, troubleshooting problems, and assessing your growing conditions, will give novices the confidence they need to begin nurturing their own collection. Includes tips and lists detailing everything from which plants are pet-friendly to the top five plants for frequent travelers."), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Heather Rodino\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Heather Rodino grew up in rural Pennsylvania surrounded by plants and gardens but has lived in urban locations for most of her adult life, making small-space and indoor gardening a necessity. A writer and editor, she is the author of several books and has worked for many years in the publishing industry. She lives in San Juan, Puerto Rico.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0